import {Box, BoxProps} from 'src/components/shared';
import styled from 'styled-components/macro';

export type FlexProps = BoxProps;

export const Flex: React.FC<FlexProps> = styled(Box)<FlexProps>({
  display: 'flex',
});
